import type { ComponentPropsWithoutRef } from 'react';

type Props = ComponentPropsWithoutRef<'a'> & {
  to: string;
};

export default function PlatformLink({ to, children, ...rest }: Props) {
  const href = to.startsWith('http')
    ? to
    : `${import.meta.env.VITE_PLATFORM_HOST}${to}`;

  return (
    <a href={href} {...rest}>
      {children}
    </a>
  );
}
